import * as React from 'react';
import Grid from '@mui/material/Grid';
import QueryFilter from '../components/Filters/QueryFilter';
import RegionFilter from '../components/Filters/RegionFilter';
import { Region } from '../BookingsCalendarTypes';

type OrderListFiltersProps = {
    availableRegions: Region[];
    selectedRegion: string;
    searchQuery: string;
    onChangeRegion: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    onSearchQuery: (event: React.ChangeEvent<HTMLSelectElement>) => void;
};

function OrderListFilters({
    availableRegions,
    selectedRegion,
    searchQuery,
    onChangeRegion,
    onSearchQuery
}: OrderListFiltersProps) {
    return (
        <Grid container spacing={2} sx={{ p: '16px' }}>
            <Grid item xs={12} md={6}>
                <QueryFilter query={searchQuery} onSearchQuery={onSearchQuery} />
            </Grid>
            <Grid item xs={12} md={6}>
                <RegionFilter
                    regions={availableRegions}
                    onChangeRegion={onChangeRegion}
                    selectedRegion={selectedRegion}
                />
            </Grid>
        </Grid>
    );
}

export default OrderListFilters;
